import { render } from "./Referee.vue?vue&type=template&id=4d76a253&scoped=true&ts=true"
import script from "./Referee.vue?vue&type=script&lang=ts"
export * from "./Referee.vue?vue&type=script&lang=ts"

import "./Referee.vue?vue&type=style&index=0&id=4d76a253&scoped=true&lang=scss"
import "./Referee.vue?vue&type=style&index=1&id=4d76a253&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d76a253"]])

export default __exports__